import React from 'react';
import { FormFeedback, FormText } from 'reactstrap';

export function HelperText({ helperType, helperText, helperFieldId }) {
    if (helperType === 'error') {
        return (
            <FormFeedback className="form-error-message" style={{ display: 'inline-block' }} id={helperFieldId}>
                {helperText}
            </FormFeedback>
        );
    }

    if (helperType === 'success') {
        return (
            <small className="form-text text-success" id={helperFieldId}>
                {helperText}
            </small>
        );
    }

    if (helperType === 'warning') {
        return (
            <small className="form-text text-warning" id={helperFieldId}>
                {helperText}
            </small>
        );
    }

    if (helperType === 'default') {
        return <FormText id={helperFieldId}>{helperText}</FormText>;
    }

    return null;
}
